import React, { useRef } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import DynamicButton from "../DynamicButton/DynamicButton";

const TableExcelActions = ({ columns, filteredData, api }) => {
  const fileInputRef = useRef(null);

  const handleDownload = () => {
    const excelData = filteredData.map((row) => {
      const flattenedRow = {};
      columns.forEach((col) => {
        const fieldPath = col.field.split(".");
        let value = row;

        for (let i = 0; i < fieldPath.length; i++) {
          if (Array.isArray(value)) {
            const remainingPath = fieldPath.slice(i).join(".");
            value = value
              .map((item) => {
                const keys = remainingPath.split(".");
                let nestedValue = item;
                for (const k of keys) nestedValue = nestedValue?.[k];
                return nestedValue;
              })
              .filter(Boolean)
              .join(", ");
            break;
          } else {
            value = value?.[fieldPath[i]];
          }
        }

        flattenedRow[col.label] = value !== undefined ? value : "";
      });
      return flattenedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FilteredData");
    XLSX.writeFile(workbook, "filtered_data.xlsx");
  };

const handleUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!api) {
    alert("⚠️ Upload is not available. Please contact the developer.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const uploadUrl = `${api}/upload`; // e.g., https://byggingapi.axiomos.in/user/upload
    const res = await axios.post(uploadUrl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    const created = res.data?.createdUsers?.length || 0;
    const skipped = res.data?.skippedUsers?.length || 0;

    alert(`✅ Upload complete.\nCreated: ${created}\nSkipped: ${skipped}`);

    // 🔄 Refresh the page after success
    window.location.reload();
  } catch (error) {
    console.error("Upload failed:", error.response?.data || error.message);
    alert(
      "❌ Upload failed. Check API or file format. See console for details."
    );
  }
};



  return (
    <div className="excel-actions" style={{ display: "flex", gap: "0.75rem" }}>
      <DynamicButton
        text="Download Excel"
        icon="fa-download"
        size="sm"
        variant="primary"
        onClick={handleDownload}
      />

      <DynamicButton
        text="Upload Excel"
        icon="fa-upload"
        size="sm"
        variant="secondary"
        onClick={() => fileInputRef.current?.click()} // 👈 manually trigger input
      />

      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls"
        onChange={handleUpload}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default TableExcelActions;
